/* eslint-disable require-jsdoc */
import {SagaIterator} from 'redux-saga';
import {call, put, select, takeLatest} from 'redux-saga/effects';

import {SpecialOfferItemType} from '../../reducers/quoteInfo/quoteInfoType';
import {getQuote, removeQuoteItem} from '../../reducers/quoteItems/quoteItems';
import {setCartSpecialOffer} from '../../reducers/specialOffer/specialOffer';
import {getQuoteSpecialOffers} from '../../selectors/quoteInfo/quoteInfo';

/**
 * Handle special offer set
 */
export function* setSpecialOffer(specialOffer: string, contentType: 'json' | 'html') {
    yield put(
        setCartSpecialOffer({
            bannerContent: specialOffer,
            contentType,
        }),
    );
}

/**
 * Validate special offers -> return specialOffers[0] and log in sentry if it needs
 */
const validateSpecialOffer = (specialOffers: Array<SpecialOfferItemType>) => {
    if (!Array.isArray(specialOffers)) return null;
    if (specialOffers.length < 1) return null;

    // We get the first banner from the array because when there are multiple banners
    // and at least one of them has JSON type, it can't be concatenated as the HTML banners are.
    return specialOffers[0];
};

/**
 * Set quote special offer saga which validate special offers and set one banner
 */
export function* setQuoteSpecialOffer() {
    const specialOffers: Array<SpecialOfferItemType> = yield select(getQuoteSpecialOffers);
    const banner: SpecialOfferItemType = yield call(validateSpecialOffer, specialOffers);
    if (banner) yield call(setSpecialOffer, banner.content, banner.content_type);
}

/**
 * Handle special offer overrides. Gets it from quoteInfo by default.
 */
function* handleCartSpecialOffer(): SagaIterator {
    yield call(setQuoteSpecialOffer);
}

/**
 * Begin of saga
 */
export default function* cartSpecialOfferSaga() {
    yield takeLatest(`${getQuote.fulfilled}`, handleCartSpecialOffer);
    yield takeLatest(`${removeQuoteItem.fulfilled}`, handleCartSpecialOffer);
}
